import * as React from 'react';
import { ArticleHeading2, Image, UIText1 } from '@cian/ui-kit';

import * as styles from './OnboardingSlideMobile.css';

type TProps = {
  src: string;
  title: string;
  text: string;
};

export const OnboardingSlideMobile: React.FC<TProps> = ({ src, title, text }) => {
  return (
    <div className={styles['container']} data-testid="OnboardingSlideMobile">
      <div className={styles['image']}>
        <Image src={src} height={220} borderRadius="4px" />
      </div>
      <div className={styles['content']}>
        <ArticleHeading2>{title}</ArticleHeading2>
        <UIText1>{text}</UIText1>
      </div>
    </div>
  );
};
